// ClientDropdown.js
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import axios from 'axios';
import { getHeaders } from '../../../lib/requests';

function ClientDropdown({ onSelect }) {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const apiToken = localStorage.getItem('accessToken');
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${apiUrl}/clients`, {
          headers: getHeaders(apiToken),
        });
        setClients(response.data.data);
      } catch (error) {
        console.error('Error fetching clients', error);
      }
    };

    fetchClients();
  }, []);

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const handleSelectClient = (client) => {
    setSelectedClient(client);
    setShowDropdown(false); // Close the dropdown after selection
    onSelect(client); // Inform the parent component about the selection
  };

  return (
    <div className="relative inline-block text-left">
      <button
        id="dropdownDefaultButton"
        data-dropdown-toggle="dropdown"
        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        type="button"
        onClick={toggleDropdown}
      >
        {selectedClient ? selectedClient.name : 'Select Client'}
        <svg className="ml-2 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 8l5 5 5-5" />
        </svg>
      </button>

      {showDropdown && (
        <div id="dropdown" className="absolute z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700">
          <ul className="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefaultButton">
            {clients.map(client => (
              <li key={client.client_id}>
                <a
                  href="#"
                  className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  onClick={(e) => {
                    e.preventDefault(); // Prevent the link from navigating
                    handleSelectClient(client);
                  }}
                >
                  {client.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

ClientDropdown.propTypes = {
    onSelect: PropTypes.func.isRequired, // Make onSelect a required prop
    };

export default ClientDropdown;

